<script setup lang="ts">
import type { StateModal } from '~/types/types'

const { withRedirection = '' } = defineProps<{
  withRedirection?: string
}>()
const route = useRoute()
const stateModal = useState<StateModal>('state-modal')

const handleSuccess = async () => {
  if (withRedirection) {
    const queryID = route.query?.queryID
    const query = queryID ? { queryID } : {}
    await navigateTo({
      path: withRedirection,
      query,
    })
  }
  stateModal.value.authPreOrderIsOpen = false
}
</script>

<template>
  <AuthModal
    v-model="stateModal.authPreOrderIsOpen"
    @on-success-login="handleSuccess"
  >
    <template #header>
      <div class="text-center">
        <div class="mb-1 text-md font-bold">
          {{ $t('auth.loginOrRegister') }}
        </div>
        <div class="mb-8 text-md">
          {{ $t('preOrder.modalAuthTextHeader') }}
        </div>
      </div>
    </template>
  </AuthModal>
</template>
